//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import action from './action';
export default {
  name: 'index',
  props: ['params'],
  metaInfo() {
    return {
      title: this.pageTitle
    };
  },
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
    ...action
  }
}



// WEBPACK FOOTER //
// ./src/module/app/communityGroupVideo/page.vue